import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import { getHouseholds } from '../../actions/households/households.actions'

import { ClientsTable } from '../../components/Tables/ClientsTable'

import { debounce } from 'lodash'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: '#FFFFFF'
	},
	addClientButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	}
}))

const Schedule = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const households = useSelector((state) => state.specific.households.households)
	const facility = useSelector((state) => state.specific.facilities.selected)

	const [search, setSearch] = useState('')
	const [searchBy, setSearchBy] = useState('')
	const [page, setPage] = useState(0)

	const delayeOnSearchChange = useRef(
		debounce((s, sb, p) => {
			setSearch(s)
			setSearchBy(sb)
			setPage(p)
		}, 750)
	).current

	useEffect(() => {
		if (search && searchBy && facility) {
			dispatch(getHouseholds(facility.market_id, encodeURIComponent(search), encodeURIComponent(searchBy), page))
		} else {
			dispatch({ type: 'CLEAR_HOUSEHOLDS' })
			dispatch({ type: 'CLEAR_ACCOUNTS' })
		}
	}, [search, searchBy, page])

	return (
		<div className={classes.root}>
			<div className={classes.visitsTableContainer}>
				<ClientsTable households={households} onSearchChange={delayeOnSearchChange} />
			</div>
		</div>
	)
}

export default Schedule
